module.exports = __webpack_public_path__ + "static/media/utilia.17486282.png";